module.exports = __webpack_public_path__ + "img/menuIcon4.93583937.png";